import React from 'react'
import NavBar from '../../components/NavBar/NavBar'
import Footer from '../../components/Footer/Footer'
import "./Primary.css"

const Primary = ({children}) => {
  return (
    <div>
     <NavBar></NavBar>
    <div className='PLayout'>
       
        {children}
        <Footer></Footer>
    </div>
    </div>
  )
}

export default Primary